
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/sdks/python",
      function () {
        return require("private-next-pages/events/sdks/python.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/sdks/python"])
      });
    }
  